<div class="d-inline-flex mt-2">
  <img class="mr-1" ngSrc="assets/icon/helper-info-grey-small.svg" alt="icon" width="12" height="12" />
  <div class="font-size-11">{{ helperText() | translate }}</div>
</div>
